import {
  encodeState,
  urlEncodeBase64
} from "./chunk-CO4RI5BX.mjs";
import {
  getApiUrl,
  getBaseUrl
} from "./chunk-XEDCQDS7.mjs";

// src/services/logout.ts
function explicitLogoutFunction(environment, request) {
  const baseUrl = getBaseUrl(environment);
  const state = urlEncodeBase64(encodeState(request));
  return `${baseUrl}/logout?state=${state}`;
}
async function implicitLogoutFunction(environment, request) {
  try {
    request.kmsiLogout = false;
    const baseUrl = getApiUrl(environment);
    const implicitLogoutResponse = await fetch(`${baseUrl}/v1/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(request)
    });
    window.location.replace(request.redirectUri);
    return implicitLogoutResponse.json();
  } catch (error) {
    const defaultLogoutResponse = {
      redirectUri: request.redirectUri,
      status: {
        USER_LOGOUT: "UNKNOWN",
        REVOKE_KMSI: "NOT_EXECUTED",
        REVOKE_REFRESH_TOKEN: "UNKNOWN"
      },
      message: error.toString()
    };
    return defaultLogoutResponse;
  }
}

export {
  explicitLogoutFunction,
  implicitLogoutFunction
};
